import { Types } from './types'

export const loginDataAction = (data) => {
  return {
    type: Types.LOGIN_DATA,
    payload: data,
  }
}

export const logoutAction = () => {
  return {
    type: Types.LOGOUT,
  }
}

export const activeSettingsDetailNavigation = (status) => {
  return {
    type: Types.ACTIVE_SETTING_DETAIL_NAVIGATION,
    payload: status,
  }
}

export const addUserAlertAction = (status) => {
  return {
    type: Types.ADD_USER_ALERT,
    payload: status,
  }
}

export const deleteUserAlertAction = (status) => {
  return {
    type: Types.DELETE_USER_ALERT,
    payload: status,
  }
}

export const notificationActiveAction = (status) => {
  return {
    type: Types.IS_NOTIFICATION_ACTIVE,
    payload: status,
  }
}

export const addSupplierAlertAction = (status) => {
  return {
    type: Types.ADD_SUPPLIER_ALERT,
    payload: status,
  }
}

export const updateSupplierAlertAction = (status) => {
  return {
    type: Types.UPDATE_SUPPLIER_ALERT,
    payload: status,
  }
}

export const addProductAlertAction = (status) => {
  return {
    type: Types.ADD_PRODUCT_ALERT,
    payload: status,
  }
}

export const updateProductAlertAction = (status) => {
  return {
    type: Types.UPDATE_PRODUCT_ALERT,
    payload: status,
  }
}

export const updateInventoryItemAlertAction = (status) => {
  return {
    type: Types.UPDATE_INVENTORY_ITEM_ALERT,
    payload: status,
  }
}
